import { render, staticRenderFns } from "./TagCreateDialog.vue?vue&type=template&id=3a18553a&scoped=true"
import script from "./TagCreateDialog.vue?vue&type=script&lang=ts"
export * from "./TagCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a18553a",
  null
  
)

export default component.exports